import { render } from "./PersianNumberField.vue?vue&type=template&id=c2527070"
import script from "./PersianNumberField.vue?vue&type=script&lang=js"
export * from "./PersianNumberField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianNumberField.vue"]])

export default __exports__